import { Link } from "react-router-dom";
import { GraduationCap, FileCheck2, ArrowUpRight, CalendarClock } from "lucide-react";
import { TRAINING_STATUS } from "@/lib/training";
import { formatDate } from "@/lib/constants";

export const TrainingStatus = ({ status, overdue, testId }) => (
  <span className="inline-flex flex-wrap items-center gap-1.5" data-testid={testId}>
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${TRAINING_STATUS[status]?.cls}`}>
      {TRAINING_STATUS[status]?.label || status}
    </span>
    {overdue && <span className="inline-flex items-center rounded-full border border-rose-200 bg-rose-50 px-2.5 py-0.5 text-[11px] font-semibold text-rose-700">Overdue</span>}
  </span>
);

export const ProgressBar = ({ pct, className = "" }) => (
  <div className={`h-1.5 w-full overflow-hidden rounded-full bg-lasso-line ${className}`}>
    <div className="h-full rounded-full bg-lasso-ink transition-[width] duration-500" style={{ width: `${pct || 0}%` }} />
  </div>
);

export const StatTile = ({ label, value, testId, tone }) => (
  <div className="rounded-2xl border border-lasso-line bg-white p-5" data-testid={testId}>
    <p className={`font-display text-3xl font-bold ${tone === "danger" && value > 0 ? "text-rose-600" : ""}`} data-testid={`${testId}-value`}>{value}</p>
    <p className="mt-1 text-xs uppercase tracking-[0.16em] text-zinc-500">{label}</p>
  </div>
);

export const TrainingItemRow = ({ item, link = true }) => {
  const Icon = item.item_type === "course" ? GraduationCap : FileCheck2;
  const to = item.item_type === "course" ? `/courses/${item.item_id}` : `/sops/${item.item_id}`;
  const body = (
    <>
      <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lasso-paper text-lasso-deep"><Icon className="h-4 w-4" /></span>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <p className="truncate text-sm font-semibold">{item.title}</p>
          <TrainingStatus status={item.status} overdue={item.overdue} />
        </div>
        <p className="mt-1 flex flex-wrap items-center gap-x-3 text-xs text-muted-foreground">
          <span>{item.item_type === "course" ? "Course" : "SOP · read & acknowledge"}</span>
          {item.due_date && <span className={`inline-flex items-center gap-1 ${item.overdue ? "font-semibold text-rose-600" : ""}`}><CalendarClock className="h-3 w-3" />Due {formatDate(item.due_date + "T12:00:00")}</span>}
          {item.completed_at && <span>Completed {formatDate(item.completed_at)}</span>}
          {item.best_score != null && <span>Best score {item.best_score}%</span>}
        </p>
        {item.item_type === "course" && item.status !== "completed" && <ProgressBar pct={item.pct} className="mt-3 max-w-xs" />}
      </div>
      {link && <ArrowUpRight className="h-4 w-4 shrink-0 text-zinc-400" />}
    </>
  );
  const cls = "flex items-start gap-4 rounded-xl border border-lasso-line bg-white p-4 transition-colors duration-200";
  const testId = `training-item-${item.item_type}-${item.item_id}`;
  return link ? <Link to={to} className={`${cls} hover:border-lasso-ink`} data-testid={testId}>{body}</Link> : <div className={cls} data-testid={testId}>{body}</div>;
};
